import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FormInput from '@components/forms/common/FormInput.component.jsx';

const DistrictQuestion = forwardRef(({ control, errors }, ref) => {
  const { t } = useTranslation();
  const { label, validation } = t('printer.form.fields.district', {
    returnObjects: true,
  });

  return (
    <Controller
      name="district"
      control={control}
      rules={{
        required: validation?.required,
        validate: (value) => {
          if (!value) return true;
          if (value.length < 5) return validation.minLength;
          if (value.length > 256) return validation.maxLength;
          return true;
        },
      }}
      render={({ field: { onChange, value } }) => (
        <FormInput
          ref={ref}
          label={label}
          value={value}
          onChange={onChange}
          onFocus={(e) => {
            setTimeout(() => {
              e.target.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest',
                block: 'center',
              });
            }, 300);
          }}
          error={errors.district}
        />
      )}
    />
  );
});

DistrictQuestion.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default DistrictQuestion;
